module.exports = __webpack_public_path__ + "static/img/LL-3.7fe7dd18.png";